module.exports = __webpack_public_path__ + "static/media/8.1376924f.jpg";